// 🏥 Base de datos CIE-10 EXPANDIDA - 250+ Diagnósticos comunes en Colombia
// Actualizado: 22-11-2025 - Blindado contra errores de edición

export const CIE10_DATABASE = [
  // INFECCIONES BACTERIANAS Y VIRALES
  { code: 'A00', description: 'Cólera' },
  { code: 'A01', description: 'Fiebre tifoidea' },
  { code: 'A02', description: 'Infección por Salmonela' },
  { code: 'A03', description: 'Disentería bacilar' },
  { code: 'A04', description: 'Gastroenteritis viral' },
  { code: 'A05', description: 'Otra intoxicación alimentaria bacteriana' },
  { code: 'A06', description: 'Amebiasis' },
  { code: 'A07', description: 'Otras infecciones intestinales especificadas' },
  { code: 'A08', description: 'Infecciones intestinales virales' },
  { code: 'A09', description: 'Diarrea y gastroenteritis' },
  { code: 'A15', description: 'Tuberculosis respiratoria' },
  { code: 'A16', description: 'Tuberculosis respiratoria no confirmada' },
  { code: 'A17', description: 'Tuberculosis del sistema nervioso' },
  { code: 'A18', description: 'Tuberculosis de otros órganos' },
  { code: 'A19', description: 'Tuberculosis miliar' },
  { code: 'B00', description: 'Infección herpética' },
  { code: 'B01', description: 'Varicela' },
  { code: 'B02', description: 'Herpes zóster' },
  { code: 'B03', description: 'Viruela' },
  { code: 'B04', description: 'Viruela del mono' },
  { code: 'B05', description: 'Sarampión' },
  { code: 'B06', description: 'Rubéola' },
  { code: 'B07', description: 'Verrugas virales' },
  { code: 'B08', description: 'Otras infecciones virales especificadas' },
  { code: 'B09', description: 'Infección viral no especificada' },
  { code: 'B10', description: 'Otras enfermedades virales especificadas' },
  { code: 'B34', description: 'Infección viral sin especificar' },
  { code: 'B99', description: 'Enfermedad infecciosa sin especificar' },
  // PARASITARIAS
  { code: 'B65', description: 'Esquistosomiasis' },
  { code: 'B66', description: 'Otras infecciones por trematodos' },
  { code: 'B67', description: 'Equinococosis' },
  { code: 'B68', description: 'Teniasis' },
  { code: 'B69', description: 'Cisticercosis' },
  { code: 'B70', description: 'Diphyllobothriasis y pseudophyllidosis' },
  { code: 'B71', description: 'Otras infecciones por céstodos' },
  { code: 'B72', description: 'Dracunculiasis' },
  { code: 'B73', description: 'Oncocercosis' },
  { code: 'B74', description: 'Filariasis' },
  { code: 'B75', description: 'Trichinellosis' },
  { code: 'B76', description: 'Anquilostomiasis y otras ancilostomosis' },
  { code: 'B77', description: 'Ascaridiasis' },
  { code: 'B78', description: 'Estrongiloidiasis' },
  { code: 'B79', description: 'Trichuriasis' },
  { code: 'B80', description: 'Enterobiasis' },
  { code: 'B81', description: 'Otras helmintiasis' },
  { code: 'B82', description: 'Helmintiasis sin especificar' },
  { code: 'B83', description: 'Otras helmintiasis especificadas' },
  { code: 'B86', description: 'Sarna' },
  { code: 'B87', description: 'Miasis' },
  { code: 'B88', description: 'Otras infestaciones' },
  { code: 'B89', description: 'Parasitosis sin especificar' },
  { code: 'B90', description: 'Secuelas de tuberculosis' },
  // ENFERMEDADES DEL SISTEMA CIRCULATORIO
  { code: 'I10', description: 'Hipertensión esencial (primaria)' },
  { code: 'I11', description: 'Enfermedad renal hipertensiva' },
  { code: 'I12', description: 'Hipertensión y enfermedad renal crónica' },
  { code: 'I13', description: 'Hipertensión con enfermedad cardiorenal' },
  { code: 'I15', description: 'Hipertensión secundaria' },
  { code: 'I20', description: 'Angina de pecho' },
  { code: 'I21', description: 'Infarto agudo del miocardio' },
  { code: 'I22', description: 'Infarto recurrente del miocardio' },
  { code: 'I24', description: 'Secuelas de infarto agudo' },
  { code: 'I25', description: 'Enfermedad isquémica crónica del corazón' },
  { code: 'I30', description: 'Pericarditis aguda' },
  { code: 'I31', description: 'Enfermedades del pericardio' },
  { code: 'I33', description: 'Miocarditis aguda' },
  { code: 'I34', description: 'Insuficiencia mitral' },
  { code: 'I35', description: 'Estenosis aórtica' },
  { code: 'I36', description: 'Endocarditis infecciosa' },
  { code: 'I37', description: 'Insuficiencia pulmonar' },
  { code: 'I38', description: 'Endocarditis en otras enfermedades' },
  { code: 'I40', description: 'Miocarditis' },
  { code: 'I42', description: 'Miocardiopatía' },
  { code: 'I50', description: 'Insuficiencia cardíaca' },
  { code: 'I51', description: 'Complicaciones y secuelas del corazón' },
  { code: 'I60', description: 'Hemorragia subaracnoidea' },
  { code: 'I61', description: 'Hemorragia intracraneal' },
  { code: 'I62', description: 'Otro accidente cerebrovascular hemorrágico' },
  { code: 'I63', description: 'Infarto cerebral' },
  { code: 'I64', description: 'Accidente cerebrovascular no especificado' },
  { code: 'I65', description: 'Oclusión y estenosis precerebral' },
  { code: 'I66', description: 'Oclusión y estenosis cerebral' },
  { code: 'I67', description: 'Otras enfermedades cerebrovasculares' },
  { code: 'I68', description: 'Accidente cerebrovascular en enfermedades' },
  { code: 'I69', description: 'Secuelas de enfermedades cerebrovasculares' },
  { code: 'I70', description: 'Aterosclerosis' },
  { code: 'I71', description: 'Disección de aorta' },
  { code: 'I72', description: 'Aneurisma' },
  { code: 'I73', description: 'Otras enfermedades vasculares periféricas' },
  { code: 'I74', description: 'Embolia y trombosis arterial' },
  { code: 'I77', description: 'Otras enfermedades de las arterias' },
  { code: 'I78', description: 'Enfermedades de los capilares' },
  { code: 'I80', description: 'Flebitis y tromboflebitis' },
  { code: 'I81', description: 'Trombosis portal' },
  { code: 'I82', description: 'Trombosis venosa' },
  { code: 'I83', description: 'Varices de miembros inferiores' },
  { code: 'I84', description: 'Hemorroides' },
  { code: 'I85', description: 'Varices esofágicas' },
  { code: 'I86', description: 'Otras varices especificadas' },
  { code: 'I87', description: 'Trastornos venosos posteriores' },
  { code: 'I88', description: 'Linfangitis' },
  { code: 'I89', description: 'Otras enfermedades no infecciosas del sistema linfático' },
  // ENFERMEDADES DEL SISTEMA RESPIRATORIO
  { code: 'J00', description: 'Rinofaringitis aguda (resfriado común)' },
  { code: 'J01', description: 'Sinusitis aguda' },
  { code: 'J02', description: 'Faringitis aguda' },
  { code: 'J03', description: 'Amigdalitis aguda' },
  { code: 'J04', description: 'Laringitis y traqueítis agudas' },
  { code: 'J05', description: 'Laringotraqueobronquitis aguda' },
  { code: 'J06', description: 'Infecciones agudas de vías respiratorias superiores' },
  { code: 'J10', description: 'Influenza por virus identificado' },
  { code: 'J11', description: 'Influenza por virus no identificado' },
  { code: 'J12', description: 'Neumonía viral' },
  { code: 'J13', description: 'Neumonía por Streptococcus pneumoniae' },
  { code: 'J14', description: 'Neumonía por Haemophilus influenzae' },
  { code: 'J15', description: 'Neumonía bacteriana' },
  { code: 'J16', description: 'Neumonía por otros microorganismos especificados' },
  { code: 'J17', description: 'Neumonía en enfermedades clasificadas en otro lugar' },
  { code: 'J18', description: 'Neumonía no especificada' },
  { code: 'J20', description: 'Bronquitis aguda' },
  { code: 'J21', description: 'Bronquiolitis aguda' },
  { code: 'J22', description: 'Infección aguda no especificada de vías respiratorias inferiores' },
  { code: 'J30', description: 'Rinitis alérgica' },
  { code: 'J31', description: 'Rinitis, faringitis y laringitis crónica' },
  { code: 'J32', description: 'Sinusitis crónica' },
  { code: 'J33', description: 'Pólipos nasales' },
  { code: 'J34', description: 'Otros trastornos de nariz y senos paranasales' },
  { code: 'J35', description: 'Enfermedades crónicas de amígdalas y adenoides' },
  { code: 'J36', description: 'Absceso periamigdalino' },
  { code: 'J37', description: 'Laringitis crónica y laringotraqueitis' },
  { code: 'J38', description: 'Enfermedades de las cuerdas vocales' },
  { code: 'J39', description: 'Otras enfermedades de la laringe' },
  { code: 'J40', description: 'Bronquitis no especificada' },
  { code: 'J41', description: 'Bronquitis crónica simple y mucopurulenta' },
  { code: 'J42', description: 'Bronquitis crónica no especificada' },
  { code: 'J43', description: 'Enfisema' },
  { code: 'J44', description: 'Enfermedad pulmonar obstructiva crónica' },
  { code: 'J45', description: 'Asma' },
  { code: 'J46', description: 'Estado asmático' },
  { code: 'J47', description: 'Bronquiectasia' },
  { code: 'J48', description: 'Otras enfermedades obstructivas de las vías respiratorias' },
  { code: 'J60', description: 'Neumoconiosis' },
  { code: 'J61', description: 'Asbestosis' },
  { code: 'J62', description: 'Talcosis y otras neumoconiosis' },
  { code: 'J63', description: 'Siderosis' },
  { code: 'J64', description: 'Beriliosis' },
  { code: 'J65', description: 'Silicosis' },
  { code: 'J66', description: 'Bisinosis' },
  { code: 'J67', description: 'Alveolitis alérgica extrínseca' },
  { code: 'J68', description: 'Afecciones de vías respiratorias por inhalación de químicos' },
  { code: 'J69', description: 'Neumonitis por aspiración' },
  { code: 'J70', description: 'Afecciones respiratorias por otras sustancias' },
  { code: 'J80', description: 'Edema pulmonar' },
  { code: 'J81', description: 'Edema pulmonar en cardiopatía' },
  { code: 'J82', description: 'Eosinofilia pulmonar' },
  { code: 'J84', description: 'Otras enfermedades del pulmón' },
  { code: 'J85', description: 'Absceso de pulmón y mediastino' },
  { code: 'J86', description: 'Empiema' },
  { code: 'J90', description: 'Derrame pleural' },
  { code: 'J91', description: 'Derrame pleural en enfermedades' },
  { code: 'J92', description: 'Placa pleural' },
  { code: 'J93', description: 'Neumotórax' },
  { code: 'J94', description: 'Otros trastornos pleurales' },
  { code: 'J95', description: 'Complicaciones de la cirugía de las vías respiratorias' },
  { code: 'J96', description: 'Insuficiencia respiratoria' },
  { code: 'J98', description: 'Otros trastornos de las vías respiratorias' },
  { code: 'J99', description: 'Enfermedades respiratorias en otras enfermedades' },
  // ENFERMEDADES ENDOCRINAS
  { code: 'E00', description: 'Síndrome de deficiencia de yodo' },
  { code: 'E01', description: 'Hipotiroidismo por deficiencia de yodo' },
  { code: 'E02', description: 'Hipotiroidismo subclínico por deficiencia de yodo' },
  { code: 'E03', description: 'Otros hipotiroidismos' },
  { code: 'E04', description: 'Otro bocio no tóxico' },
  { code: 'E05', description: 'Tirotoxicosis (hipertiroidismo)' },
  { code: 'E06', description: 'Tiroiditis' },
  { code: 'E07', description: 'Otros trastornos de la glándula tiroides' },
  { code: 'E10', description: 'Diabetes mellitus tipo 1' },
  { code: 'E11', description: 'Diabetes mellitus tipo 2' },
  { code: 'E12', description: 'Diabetes mellitus relacionada con desnutrición' },
  { code: 'E13', description: 'Otra diabetes mellitus especificada' },
  { code: 'E14', description: 'Diabetes mellitus no especificada' },
  { code: 'E15', description: 'Hipoglucemia no especificada' },
  { code: 'E16', description: 'Otros trastornos del páncreas endocrino' },
  { code: 'E20', description: 'Hipoparatiroidismo' },
  { code: 'E21', description: 'Hiperparatiroidismo' },
  { code: 'E22', description: 'Hiperfunción de la glándula pituitaria' },
  { code: 'E23', description: 'Hipofunción de la glándula pituitaria' },
  { code: 'E24', description: 'Síndrome de Cushing' },
  { code: 'E25', description: 'Adrenogenitalismo' },
  { code: 'E26', description: 'Hiperaldosteronismo' },
  { code: 'E27', description: 'Insuficiencia adrenocortical' },
  { code: 'E28', description: 'Otros trastornos del ovario' },
  { code: 'E29', description: 'Otros trastornos testiculares' },
  { code: 'E30', description: 'Trastornos del pubis' },
  { code: 'E31', description: 'Poliglandulopatía autoinmune' },
  { code: 'E34', description: 'Otros trastornos endocrinos' },
  { code: 'E35', description: 'Trastornos endocrinos en enfermedades' },
  { code: 'E40', description: 'Desnutrición proteico-calórica' },
  { code: 'E41', description: 'Desnutrición proteica' },
  { code: 'E42', description: 'Marasmo' },
  { code: 'E43', description: 'Kwashiorkor' },
  { code: 'E44', description: 'Desnutrición proteico-calórica de grado moderado' },
  { code: 'E45', description: 'Retraso del desarrollo debido a desnutrición' },
  { code: 'E46', description: 'Desnutrición sin especificar' },
  // TRASTORNOS MENTALES Y DEL COMPORTAMIENTO
  { code: 'F10', description: 'Trastornos por uso de alcohol' },
  { code: 'F11', description: 'Trastornos por uso de opioides' },
  { code: 'F12', description: 'Trastornos por uso de cannabinoides' },
  { code: 'F13', description: 'Trastornos por uso de sedantes o hipnóticos' },
  { code: 'F14', description: 'Trastornos por uso de cocaína' },
  { code: 'F15', description: 'Trastornos por uso de otros estimulantes' },
  { code: 'F16', description: 'Trastornos por uso de alucinógenos' },
  { code: 'F17', description: 'Trastornos por uso de tabaco' },
  { code: 'F18', description: 'Trastornos por uso de disolventes volátiles' },
  { code: 'F19', description: 'Trastornos por uso de múltiples drogas' },
  { code: 'F20', description: 'Esquizofrenia' },
  { code: 'F21', description: 'Trastorno esquizotípico' },
  { code: 'F22', description: 'Trastornos delirantes persistentes' },
  { code: 'F23', description: 'Trastornos psicóticos agudos y transitorios' },
  { code: 'F24', description: 'Trastorno delirante compartido' },
  { code: 'F25', description: 'Trastorno esquizoafectivo' },
  { code: 'F28', description: 'Otros trastornos psicóticos no orgánicos especificados' },
  { code: 'F29', description: 'Psicosis no especificada' },
  { code: 'F30', description: 'Episodio maníaco' },
  { code: 'F31', description: 'Trastorno bipolar' },
  { code: 'F32', description: 'Episodio depresivo' },
  { code: 'F33', description: 'Trastorno depresivo recurrente' },
  { code: 'F34', description: 'Trastornos del humor persistentes' },
  { code: 'F38', description: 'Otros trastornos del humor' },
  { code: 'F39', description: 'Trastorno del humor sin especificar' },
  { code: 'F40', description: 'Trastornos de ansiedad fóbica' },
  { code: 'F41', description: 'Otros trastornos de ansiedad' },
  { code: 'F42', description: 'Trastorno obsesivo-compulsivo' },
  { code: 'F43', description: 'Reacción al estrés grave y trastorno de adaptación' },
  { code: 'F44', description: 'Trastornos disociativos' },
  { code: 'F45', description: 'Trastornos somatomorfos' },
  { code: 'F48', description: 'Otros trastornos neuróticos' },
  { code: 'F50', description: 'Trastornos de la conducta alimentaria' },
  { code: 'F51', description: 'Trastornos del sueño no orgánicos' },
  { code: 'F52', description: 'Disfunción sexual' },
  { code: 'F53', description: 'Trastorno mental posparto no especificado' },
  { code: 'F54', description: 'Factores psicológicos asociados a enfermedades' },
  // ENFERMEDADES DEL SISTEMA DIGESTIVO
  { code: 'K00', description: 'Trastornos del desarrollo de dientes' },
  { code: 'K01', description: 'Dientes incluidos' },
  { code: 'K02', description: 'Caries dental' },
  { code: 'K03', description: 'Otras enfermedades de los dientes' },
  { code: 'K04', description: 'Enfermedades de la pulpa dental' },
  { code: 'K05', description: 'Gingivitis y enfermedad periodontal' },
  { code: 'K06', description: 'Otros trastornos de encías' },
  { code: 'K07', description: 'Anomalías de la mandíbula' },
  { code: 'K08', description: 'Otras enfermedades de los dientes y estructuras de soporte' },
  { code: 'K09', description: 'Quistes de regiones óseas de la mandíbula' },
  { code: 'K10', description: 'Otras enfermedades de la mandíbula' },
  { code: 'K11', description: 'Enfermedades de la glándula salival' },
  { code: 'K12', description: 'Estomatitis y afecciones relacionadas' },
  { code: 'K13', description: 'Otras enfermedades de la boca' },
  { code: 'K14', description: 'Enfermedades de la lengua' },
  { code: 'K20', description: 'Esofagitis' },
  { code: 'K21', description: 'Enfermedad de reflujo gastroesofágico' },
  { code: 'K22', description: 'Otras enfermedades del esófago' },
  { code: 'K23', description: 'Trastornos del esófago en enfermedades' },
  { code: 'K25', description: 'Úlcera gástrica' },
  { code: 'K26', description: 'Úlcera duodenal' },
  { code: 'K27', description: 'Úlcera péptica de sitio no especificado' },
  { code: 'K28', description: 'Úlcera gastroyeyunal' },
  { code: 'K29', description: 'Gastritis y duodenitis' },
  { code: 'K30', description: 'Dispepsia' },
  { code: 'K31', description: 'Otras enfermedades del estómago' },
  { code: 'K32', description: 'Hernia diafragmática' },
  { code: 'K35', description: 'Apendicitis aguda' },
  { code: 'K36', description: 'Apendicitis crónica' },
  { code: 'K37', description: 'Apendicitis sin especificar' },
  { code: 'K38', description: 'Otras enfermedades del apéndice' },
  { code: 'K40', description: 'Hernia inguinal' },
  { code: 'K41', description: 'Hernia femoral' },
  { code: 'K42', description: 'Hernia umbilical' },
  { code: 'K43', description: 'Hernia ventral' },
  { code: 'K44', description: 'Hernia diafragmática' },
  { code: 'K45', description: 'Otras hernias de la pared abdominal' },
  { code: 'K46', description: 'Hernia no especificada' },
  { code: 'K50', description: 'Enfermedad de Crohn' },
  { code: 'K51', description: 'Colitis ulcerativa' },
  { code: 'K52', description: 'Otras colitis y gastroenteritis no infecciosas' },
  { code: 'K55', description: 'Isquemia vascular del intestino' },
  { code: 'K56', description: 'Íleo paralítico e íleo mecánico' },
  { code: 'K57', description: 'Diverticulitis del intestino' },
  { code: 'K58', description: 'Síndrome del intestino irritable' },
  { code: 'K59', description: 'Otros trastornos funcionales del intestino' },
  { code: 'K60', description: 'Fisura y fístula del ano' },
  { code: 'K61', description: 'Absceso anal' },
  { code: 'K62', description: 'Otras enfermedades del ano y del recto' },
  { code: 'K63', description: 'Otras enfermedades del intestino' },
  { code: 'K64', description: 'Hemorroides' },
  { code: 'K65', description: 'Peritonitis' },
  { code: 'K66', description: 'Otros trastornos del peritoneo' },
  { code: 'K67', description: 'Apendicitis en peritonitis' },
  { code: 'K68', description: 'Trastornos del espacio subperitoneal' },
  { code: 'K70', description: 'Enfermedad hepática alcohólica' },
  { code: 'K71', description: 'Trastorno hepático tóxico' },
  { code: 'K72', description: 'Insuficiencia hepática' },
  { code: 'K73', description: 'Hepatitis crónica no especificada' },
  { code: 'K74', description: 'Fibrosis y cirrosis hepática' },
  { code: 'K75', description: 'Otras inflamaciones del hígado' },
  { code: 'K76', description: 'Otras enfermedades del hígado' },
  { code: 'K77', description: 'Trastorno hepático en enfermedades' },
  { code: 'K80', description: 'Colelitiasis' },
  { code: 'K81', description: 'Colecistitis' },
  { code: 'K82', description: 'Otras enfermedades de la vesícula biliar' },
  { code: 'K83', description: 'Enfermedades de los conductos biliares' },
  { code: 'K85', description: 'Pancreatitis aguda' },
  { code: 'K86', description: 'Otras enfermedades del páncreas' },
  { code: 'K87', description: 'Trastornos digestivos en enfermedades' },
  { code: 'K90', description: 'Malabsorción' },
  { code: 'K91', description: 'Complicaciones de cirugía digestiva' },
  { code: 'K92', description: 'Otras enfermedades del sistema digestivo' },
  // DOLOR Y SÍNTOMAS GENERALES
  { code: 'R00', description: 'Anomalías del ritmo cardíaco' },
  { code: 'R01', description: 'Hallazgos anormales en examen cardiovascular' },
  { code: 'R02', description: 'Gangrena' },
  { code: 'R03', description: 'Hallazgos anormales de presión arterial' },
  { code: 'R04', description: 'Hemorragia de vías respiratorias' },
  { code: 'R05', description: 'Fiebre de origen desconocido' },
  { code: 'R06', description: 'Anomalías de la respiración' },
  { code: 'R07', description: 'Dolor de garganta y pecho' },
  { code: 'R09', description: 'Síntomas respiratorios anormales' },
  { code: 'R10', description: 'Dolor abdominal' },
  { code: 'R11', description: 'Náuseas y vómitos' },
  { code: 'R12', description: 'Pirosis' },
  { code: 'R13', description: 'Disfagia' },
  { code: 'R14', description: 'Flatulencia y afecciones relacionadas' },
  { code: 'R15', description: 'Diarrea' },
  { code: 'R16', description: 'Hepatomegalia y esplenomegalia' },
  { code: 'R17', description: 'Ictericia no especificada' },
  { code: 'R18', description: 'Ascitis' },
  { code: 'R19', description: 'Síntomas abdominales anormales' },
  { code: 'R20', description: 'Disturbios de la sensibilidad de piel' },
  { code: 'R21', description: 'Erupción y otras afecciones de piel' },
  { code: 'R22', description: 'Protuberancias y tumoraciones localizadas de piel' },
  { code: 'R23', description: 'Cambios de la piel' },
  { code: 'R25', description: 'Movimientos involuntarios anormales' },
  { code: 'R26', description: 'Dificultades para caminar y movilidad' },
  { code: 'R27', description: 'Otros problemas relacionados con coordinación' },
  { code: 'R29', description: 'Síntomas y signos del sistema nervioso' },
  { code: 'R30', description: 'Disuria' },
  { code: 'R31', description: 'Hematuria no especificada' },
  { code: 'R32', description: 'Incontinencia urinaria' },
  { code: 'R33', description: 'Retención de orina' },
  { code: 'R34', description: 'Anuria y oliguria' },
  { code: 'R35', description: 'Poliuria' },
  { code: 'R36', description: 'Secreción uretral' },
  { code: 'R39', description: 'Síntomas del sistema genitourinario' },
  { code: 'R40', description: 'Somnolencia, estupor y coma' },
  { code: 'R41', description: 'Síntomas relacionados con cognición' },
  { code: 'R42', description: 'Mareos y vértigos' },
  { code: 'R43', description: 'Disturbios del olfato y gusto' },
  { code: 'R44', description: 'Síntomas relacionados con funciones intelectuales' },
  { code: 'R45', description: 'Síntomas del estado emocional' },
  { code: 'R46', description: 'Hallazgos anormales en examen' },
  { code: 'R47', description: 'Defectos de habla y lenguaje' },
  { code: 'R48', description: 'Dispraxia y otros problemas neurológicos' },
  { code: 'R50', description: 'Fiebre de origen desconocido' },
  { code: 'R51', description: 'Cefalea (dolor de cabeza)' },
  { code: 'R52', description: 'Dolor no clasificado en otro lugar' },
  { code: 'R53', description: 'Malestar y fatiga' },
  { code: 'R54', description: 'Edad y cambios relacionados' },
  { code: 'R55', description: 'Síncope y colapso' },
  { code: 'R56', description: 'Convulsiones no febriles' },
  { code: 'R57', description: 'Choque' },
  { code: 'R58', description: 'Hemorragia no clasificada' },
  { code: 'R59', description: 'Linfadenopatía' },
  { code: 'R60', description: 'Edema no clasificado' },
  { code: 'R61', description: 'Hiperhidrosis' },
  { code: 'R62', description: 'Falta de crecimiento y aumento de peso' },
  { code: 'R63', description: 'Síntomas relativos a ingestión de alimentos' },
  { code: 'R64', description: 'Caquexia' },
  { code: 'R65', description: 'Síndrome de respuesta inflamatoria sistémica' },
  { code: 'R69', description: 'Enfermedad desconocida o no especificada' },
  // ENFERMEDADES DEL SISTEMA GENITOURINARIO
  { code: 'N00', description: 'Glomerulonefritis aguda' },
  { code: 'N01', description: 'Síndrome nefrítico rápidamente progresivo' },
  { code: 'N03', description: 'Glomerulonefritis crónica' },
  { code: 'N04', description: 'Síndrome nefrótico' },
  { code: 'N05', description: 'Glomerulonefritis no especificada' },
  { code: 'N10', description: 'Pielonefritis aguda' },
  { code: 'N11', description: 'Pielonefritis crónica' },
  { code: 'N12', description: 'Pielonefritis sin cicatrización renal' },
  { code: 'N13', description: 'Uropatía obstructiva' },
  { code: 'N14', description: 'Nefropatía no especificada' },
  { code: 'N15', description: 'Enfermedad renal tubulointersticial' },
  { code: 'N16', description: 'Trastorno renal en enfermedades' },
  { code: 'N17', description: 'Insuficiencia renal aguda' },
  { code: 'N18', description: 'Enfermedad renal crónica' },
  { code: 'N19', description: 'Insuficiencia renal no especificada' },
  { code: 'N20', description: 'Cálculos del sistema urinario' },
  { code: 'N21', description: 'Cálculos en vejiga y uretra' },
  { code: 'N22', description: 'Cálculos urinarios en enfermedades' },
  { code: 'N23', description: 'Cólico nefrético no especificado' },
  { code: 'N25', description: 'Consecuencias de enfermedad renal tubulointersticial' },
  { code: 'N26', description: 'Riñón atrófico unilateral' },
  { code: 'N27', description: 'Riñón pequeño de etiología desconocida' },
  { code: 'N28', description: 'Otros trastornos de riñones y uréteres' },
  { code: 'N29', description: 'Otras enfermedades renales' },
  { code: 'N30', description: 'Cistitis' },
  { code: 'N31', description: 'Neurogenia de vejiga' },
  { code: 'N32', description: 'Otras enfermedades de vejiga' },
  { code: 'N33', description: 'Trastorno de vejiga en enfermedades' },
  { code: 'N34', description: 'Uretritis' },
  { code: 'N35', description: 'Estenosis uretral' },
  { code: 'N36', description: 'Otras enfermedades de uretra' },
  { code: 'N37', description: 'Trastorno uretral en enfermedades' },
  { code: 'N39', description: 'Otros trastornos del sistema urinario' },
  { code: 'N40', description: 'Hiperplasia de próstata' },
  { code: 'N41', description: 'Inflamación de próstata' },
  { code: 'N42', description: 'Otros trastornos de próstata' },
  { code: 'N43', description: 'Hidrocele' },
  { code: 'N44', description: 'Testículo torsionado' },
  { code: 'N45', description: 'Orquitis y epididimitis' },
  { code: 'N46', description: 'Azoospermia' },
  { code: 'N47', description: 'Fimosis y parafimosis' },
  { code: 'N48', description: 'Inflamación del pene' },
  { code: 'N50', description: 'Otros trastornos órganos genitales masculinos' },
  // TRAUMATISMO (LESIONES)
  { code: 'S00', description: 'Traumatismo de cabeza' },
  { code: 'S10', description: 'Traumatismo de cuello' },
  { code: 'S20', description: 'Traumatismo de tórax' },
  { code: 'S30', description: 'Traumatismo de abdomen, espalda baja' },
  { code: 'S40', description: 'Traumatismo de hombro' },
  { code: 'S50', description: 'Traumatismo de codo' },
  { code: 'S60', description: 'Traumatismo de muñeca y mano' },
  { code: 'S70', description: 'Traumatismo de cadera y muslo' },
  { code: 'S80', description: 'Traumatismo de rodilla' },
  { code: 'S90', description: 'Traumatismo de tobillo y pie' },
  // QUEMADURAS
  { code: 'T20', description: 'Quemaduras de cabeza y cuello' },
  { code: 'T21', description: 'Quemaduras de tronco' },
  { code: 'T22', description: 'Quemaduras de miembro superior' },
  { code: 'T23', description: 'Quemaduras de muñeca y mano' },
  { code: 'T24', description: 'Quemaduras de miembro inferior' },
  // ENVENENAMIENTO
  { code: 'T36', description: 'Envenenamiento por antibióticos sistémicos' },
  { code: 'T39', description: 'Envenenamiento por antiinflamatorios' },
  { code: 'T40', description: 'Envenenamiento por drogas narcóticas' },
  { code: 'T41', description: 'Envenenamiento por anestésicos' },
  { code: 'T42', description: 'Envenenamiento por anticonvulsivos' },
  { code: 'T43', description: 'Envenenamiento por psicotrópicos' },
  { code: 'T50', description: 'Envenenamiento por otros fármacos' },
];

// ✅ FUNCIÓN CORREGIDA: Búsqueda segura
export const searchCIE10 = (query) => {
  if (!query || typeof query !== 'string' || query.trim().length === 0) return [];
  
  const searchTerm = query.toLowerCase().trim();
  
  return CIE10_DATABASE.filter(item => 
    item.code.toLowerCase().includes(searchTerm) || 
    item.description.toLowerCase().includes(searchTerm)
  ).slice(0, 15);
};

// ✅ FUNCIÓN CORREGIDA: Obtención segura por código
export const getDescriptionByCode = (code) => {
  if (!code || typeof code !== 'string') return null;

  const item = CIE10_DATABASE.find(d => d.code === code);
  return item ? item.description : null;
};

// ✅ FUNCIÓN CORREGIDA: Obtención segura por descripción
export const getCodeByDescription = (description) => {
  if (!description || typeof description !== 'string') return null;

  const item = CIE10_DATABASE.find(d => 
    d.description.toLowerCase() === description.toLowerCase()
  );
  return item ? item.code : null;
};